import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { DropDownListModule } from "@progress/kendo-angular-dropdowns";
import { CalendarioModule } from "../../../../shared/components/calendario/calendario.module";
import { RecepcionVehiculoService } from "../../../modulos/taller/componentes/recepcion-vehiculo/recepcion-vehiculo.service";
import { ModalEsaComponent } from "./modal-esa.component";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        DropDownListModule,
        CalendarioModule
    ],
    declarations: [
        ModalEsaComponent
    ],
    exports: [
        ModalEsaComponent
    ],
    providers: [
        RecepcionVehiculoService
    ]
})
export class ModalEsaModule { }
